"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "SupportContracts";

export default {
  getInfoSupportContract() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetInfoSupportContract`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveSupportContract(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveContract`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  contractRecInfo(contractId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/ContractRecInfo`,
        `?contractID=${contractId}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  }
};
